/** base map **/
import {localizeI18nObj} from "./i18n";

export const MAP_LAYERS_ALL = "ALL";
export const MAP_LAYERS_NONE = "NONE";

export const getMapLayerOptions = t => [
  {
    value: MAP_LAYERS_ALL,
    label: t ? t("components.map.layers.all") : MAP_LAYERS_ALL
  },
  {
    value: MAP_LAYERS_NONE,
    label: t ? t("components.map.layers.none") : MAP_LAYERS_NONE
  }
];

/** classification method **/

export const MAP_CLASSIFICATION_METHOD_EQUAL_INTERVAL = "equal_interval";
export const MAP_CLASSIFICATION_METHOD_NATURAL_BREAKS = "jenks";
export const MAP_CLASSIFICATION_METHOD_QUANTILE = "quantile";
export const MAP_CLASSIFICATION_METHOD_CUSTOM_INTERVALS = "custom_intervals";

export const getMapClassificationMethodOptions = t => [
  {
    value: MAP_CLASSIFICATION_METHOD_EQUAL_INTERVAL,
    label: t ? t("components.map.classificationMethod.equalsInterval") : MAP_CLASSIFICATION_METHOD_EQUAL_INTERVAL
  },
  {
    value: MAP_CLASSIFICATION_METHOD_NATURAL_BREAKS,
    label: t ? t("components.map.classificationMethod.naturalBreaks") : MAP_CLASSIFICATION_METHOD_NATURAL_BREAKS
  },
  {
    value: MAP_CLASSIFICATION_METHOD_QUANTILE,
    label: t ? t("components.map.classificationMethod.quantile") : MAP_CLASSIFICATION_METHOD_QUANTILE
  },
  {
    value: MAP_CLASSIFICATION_METHOD_CUSTOM_INTERVALS,
    label: t ? t("components.map.classificationMethod.customIntervals") : MAP_CLASSIFICATION_METHOD_CUSTOM_INTERVALS
  }
];

export const getLayerOptions = (mapLayer, initialBaseLayer, mapLayersConfig, defaultLanguage, languages) => {
  let baseLayer, layers;

  if (mapLayer === MAP_LAYERS_NONE) {
    baseLayer = null;
    layers = [];
  } else if (mapLayer === MAP_LAYERS_ALL) {
    baseLayer = initialBaseLayer;
    layers = mapLayersConfig;
  } else {
    baseLayer = mapLayer;
    layers = mapLayersConfig.filter(({id}) => id === mapLayer);
  }

  if (layers) {
    layers = layers.map(({name, credits, ...layer}) => ({
      ...layer,
      name: localizeI18nObj(name, defaultLanguage, languages),
      credits: localizeI18nObj(credits, defaultLanguage, languages)
    }));
  }

  return {
    baseLayer: baseLayer,
    layers: layers
  };
};

export const getTranslationOptions = t => ({
  configure: t("components.map.translation.configure"),
  opacity: t("components.map.translation.opacity"),
  from: t("components.map.translation.from"),
  to: t("components.map.translation.to"),
  cancel: t("components.map.translation.cancel"),
  apply: t("components.map.translation.apply"),
  classification: t("components.map.translation.classification"),
  equalInterval: t("components.map.translation.equalInterval"),
  naturalBreaks: t("components.map.translation.naturalBreaks"),
  quantile: t("components.map.translation.quantile"),
  customIntervals: t("components.map.translation.customIntervals"),
  customIntervalsFrom: t("components.map.translation.customIntervalsFrom"),
  customIntervalsTo: t("components.map.translation.customIntervalsTo"),
  numberOfClasses: t("components.map.translation.numberOfClasses"),
  startColor: t("components.map.translation.startColor"),
  endColor: t("components.map.translation.endColor"),
  preview: t("components.map.translation.preview"),
  collapse: t("components.map.translation.collapse"),
  uncollapse: t("components.map.translation.uncollapse"),
  allowedPaletteCardinality: ({min, max}) =>
    t("components.map.translation.allowedPaletteCardinality", {min: min, max: max}),
  invalidCustomIntervals: t("components.map.translation.invalidCustomIntervals"),
  linearSelectionTooltip: step => {
    if (step === 0) {
      return t("components.map.translation.linearSelectionTooltip.step0");
    } else {
      return t("components.map.translation.linearSelectionTooltip.steps");
    }
  },
  polygonalSelectionTooltip: step => {
    if (step === 0) {
      return t("components.map.translation.polygonalSelectionTooltip.step0");
    } else if (step === 1) {
      return t("components.map.translation.polygonalSelectionTooltip.step1");
    } else {
      return t("components.map.translation.polygonalSelectionTooltip.steps");
    }
  },
  rectangularSelectionTooltip: step => {
    if (step === 0) {
      return t("components.map.translation.rectangularSelectionTooltip.step0");
    } else {
      return t("components.map.translation.rectangularSelectionTooltip.steps");
    }
  },
  circularSelectionTooltip: (step, infos) => {
    if (step === 0) {
      return t("components.map.translation.circularSelectionTooltip.step0");
    } else {
      if (infos && infos.diameter) {
        const formatter = diameter => {
          if (diameter < 1000) {
            return Math.round(diameter) + " m";
          } else if (diameter < 10000) {
            return (diameter / 1000).toFixed(1) + " km";
          } else {
            return Math.round(diameter / 1000) + " km";
          }
        };
        return t("components.map.translation.circularSelectionTooltip.stepsWithDiameter", {
          diameter: formatter(infos.diameter)
        });
      } else {
        return t("components.map.translation.circularSelectionTooltip.steps");
      }
    }
  },
  zoomIn: t("components.map.translation.zoomIn"),
  zoomOut: t("components.map.translation.zoomOut"),
  zoomHome: t("components.map.translation.zoomHome"),
  linearSelection: t("components.map.translation.linearSelection"),
  polygonalSelection: t("components.map.translation.polygonalSelection"),
  rectangularSelection: t("components.map.translation.rectangularSelection"),
  circularSelection: t("components.map.translation.circularSelection"),
  clearSelection: t("components.map.translation.clearSelection"),
  configureLayers: t("components.map.translation.configureLayers"),
  changeBaseLayer: t("components.map.translation.changeBaseLayer"),
  abortSelection: t("components.map.translation.abortSelection"),
  expandSelectionButtons: t("components.map.translation.expandSelectionButtons"),
  collapseSelectionButtons: t("components.map.translation.collapseSelectionButtons"),
  noBaseLayer: t("components.map.translation.noBaseLayer")
});
